export default {
  menuItems: [
    {
      name: "トップ",
      url: "/",
    },
    {
      name: "ゲーム概要",
      url: "/about",
    },
    {
      name: "物語",
      url: "/story",
    },
    {
      name: "システム",
      url: "/system",
    },
    {
      name: "商品情報",
      url: "/product",
    },
  ],
};
